import { render, staticRenderFns } from "./RelateUmProblema.vue?vue&type=template&id=da5e0772&scoped=true&"
import script from "./RelateUmProblema.vue?vue&type=script&lang=js&"
export * from "./RelateUmProblema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e0772",
  null
  
)

export default component.exports